import add from "@/assets/add.svg";
import Button from "@/common/elements/Button";
import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import Table from "@/common/elements/Table";
import {
  InmateDetailsTableContainer,
  TableHeader,
} from "@/components/InmateDetails/styles";
import { useEffect, useRef, useState } from "react";
import MedicalInfoModal from "./MedicalInfoModal";
import { StyledFlex } from "@/common/styles";
import DataTable from "@/common/elements/DataTable";
import { useDispatch, useSelector } from "react-redux";
import { isNonEmptyVariable } from "@/util/common_function";
import _ from "lodash";
import { v4 as uuidV4 } from "uuid";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import dayjs from "dayjs";
import API_ENDPOINTS from "@/util/api";
import Popconfirm from "@/common/elements/Popconfirm";

const MedicalTableHeaders = [
  { key: "id", text: "#" },
  { key: "medicalRecord", text: "Medical Record" },
  { key: "serviceDate", text: "Service Date" },
  { key: "comment", text: "Comment" },
];

const MedicalInfo = () => {
  const dispatch = useDispatch();
  const { bookings,bookingsFieldsEnabled } = useSelector((s) => s?.bookings);
  const [isModalShown, setIsModalShown] = useState(false);
  const [medicalInfoList, setMedicalInfoList] = useState([]);
  const [selectMedicalInfo, setSelectMedicalInfo] = useState(null);
  const dataTableRef = useRef();

  
  useEffect(() => {
    if (isNonEmptyVariable(bookings)) {
      if (bookings?.medHistoryHr?.length) {
        const med = bookings?.medHistoryHr?.map((m, index) => {
          return {
            ...m,
            id: index + 1,
            uuid: uuidV4(),
          };
        });
        setMedicalInfoList(() => med);
      } else {
        setMedicalInfoList(() => []);
      }
    }
  }, [bookings]);

  const onRowClick = (value, index) => {
    if (isNonEmptyVariable(value)) {
      const data = {
        ...value,
        serviceDate: isNonEmptyVariable(value?.serviceDate)
          ? dayjs(value?.serviceDate)
          : null,
      };
      setSelectMedicalInfo(data);
      if(index !== null && index !== undefined) {
        onEditClick();
      }
    }
  };

  const onAddClick = () => {
    // setSelectMedicalInfo(() => null);
    setIsModalShown(true);
  };

  const onEditClick = () => {
    setIsModalShown(true);
  };

  const handleCancel = () => {
    setIsModalShown(() => false);
    setSelectMedicalInfo(() => null);
    dataTableRef.current.resetAll();
  };

  const handleSubmit = (values) => {
    let medicalInfoListData = _.cloneDeep(medicalInfoList);
    if (isNonEmptyVariable(selectMedicalInfo)) {
      medicalInfoListData = medicalInfoListData?.map((m) => {
        if (m?.uuid === selectMedicalInfo?.uuid) {
          return {
            ...m,
            ...values,
          };
        }

        return m;
      });
    } else {
      medicalInfoListData.push(values);
    }

    setMedicalInfoList(() => medicalInfoListData);
    dispatch(
      setBookings({
        medHistoryHr: medicalInfoListData,
      })
    );

    handleCancel();
  };

  const handleDelete = () => {
    let medicalInfoListData = _.cloneDeep(medicalInfoList);
    if (isNonEmptyVariable(selectMedicalInfo)) {
      medicalInfoListData = medicalInfoListData?.filter(
        (m) => m?.uuid !== selectMedicalInfo?.uuid
      );

      if (isNonEmptyVariable(selectMedicalInfo?.medHistoryHrId)) {
        const url =
          API_ENDPOINTS.staff.medicalInfo.delete +
          selectMedicalInfo?.medHistoryHrId;
        dispatch(setDeleteAPis(url));
      }
    }

    setMedicalInfoList(() => medicalInfoListData);
    dispatch(
      setBookings({
        medHistoryHr: medicalInfoListData,
      })
    );

    handleCancel();
  };

  return (
    <>
      <InmateDetailsTableContainer>
        <TableHeader>
          <h6>Medical Information</h6>
          <StyledFlex gap="10px">
            <Button color="primary" type="primary" onClick={onAddClick} disabled={!bookingsFieldsEnabled}>
              Add
            </Button>
            <Button
              color="primary"
              type="primary"
              onClick={onEditClick}
              disabled={selectMedicalInfo === null ||!bookingsFieldsEnabled}
            >
              Details
            </Button>
            <Popconfirm
              title="Delete the medical info"
              description="Are you sure to delete this medical info?"
              onConfirm={handleDelete}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                color="primary"
                type="primary"
                disabled={selectMedicalInfo === null ||!bookingsFieldsEnabled}
              >
                Delete
              </Button>
            </Popconfirm>

            <Button
              onClick={handleCancel}
              disabled={selectMedicalInfo === null||!bookingsFieldsEnabled}
            >
              Cancel
            </Button>
          </StyledFlex>
        </TableHeader>
        <DataTable
          ref={dataTableRef}
          rowUniqueId="uuid"
          headers={MedicalTableHeaders}
          data={medicalInfoList}
          style={{ padding: "unset" }}
          onRowClick={onRowClick}
          selected={selectMedicalInfo === null}
          allowTableSorting={true}
        />
      </InmateDetailsTableContainer>
      <MedicalInfoModal
        show={isModalShown}
        handleCancel={handleCancel}
        formSubmit={handleSubmit}
        selectMedicalInfo={selectMedicalInfo}
        bookingsFieldsEnabled={bookingsFieldsEnabled}
      />
    </>
  );
};

export default MedicalInfo;
